import React from "react";
import { Link } from "react-router-dom";

const AdminLoginPage = () => {
  return (
    <>
   
    
    <div className="container-xxl py-5">
      <div className="container py-5">
        <div className="row g-5 justify-content-center">
          <div className="col-lg-4 wow fadeIn" data-wow-delay="0.1s">
            <img className="img-fluid m-0" src="/images/menu-1.jpg" alt="" />
          </div>
          <div className="col-lg-4 wow fadeIn text-white text-left" data-wow-delay="0.5s">
          <form action="/" className="contact-form">
              <div className="row">
              <div className="heading-section" data-aos="fade-up">
              <p className="subheading">Login</p>
             
            </div>
                <div className="mt-5">
                  <div className="form-group">
                    <input type="text" className="form-control" placeholder="Your Email" />
                  </div>
                </div>
              </div>
              <div className="">
              <div className="form-group">
                <input type="password" className="form-control" placeholder="Password" />
              </div>
           </div>
              <div className="form-group">
                <input type="submit" value="LOGIN" className=" btn btn-primary py-3 px-5 rounded-0" />
              </div>
              <div>
                <p> Create an account ?  <span className="primary-color"><Link className="nav-link" to="/register">Register</Link></span></p>
              </div>
            </form>
      
           
           
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default AdminLoginPage;
